module.exports = __webpack_public_path__ + "static/1-f6bd48fb055c582c8928a83c7ef86fa1.jpg";